import React from "react";
import FeatherIcon from "feather-icons-react";
import "./Loading.scss";
import Spinner from "../Spinner";

export default function Loading({ title, text, type, doingSignout }) {
  return (
    <div className="c-loading-wrapper" style={doingSignout ? {backgroundColor: "#F5F7F9", zIndex:9000} : {}}>
      <Spinner size={60}/>
    </div>
  );
}
